import React, { useState } from 'react';
import {
  ImageBackground,
  ImageSourcePropType,
  StyleSheet,
  View,
} from 'react-native';
import IconAvatar from 'shared/components/vxl/avatar/IconAvatar/IconAvatar';
import theme from 'shared/styles/theme';

interface OfferDetailsHeaderProps {
  heroImage: string | undefined;
  logoImage: string | undefined;
  defaultHeroImage: ImageSourcePropType;
}

const SelfFundedOfferDetailsHeader = ({
  heroImage,
  logoImage,
  defaultHeroImage,
}: OfferDetailsHeaderProps) => {
  const [showHeroImage, setShowHeroImage] = useState<boolean>(true);

  return (
    <ImageBackground
      testID="image-background"
      style={styles.heroImageLogo}
      source={
        showHeroImage
          ? {
              uri: heroImage,
            }
          : defaultHeroImage
      }
      role="img"
      accessible
      accessibilityLabel="offer-hero-image"
      onError={() => setShowHeroImage(false)}
    >
      <View style={styles.logo} testID="icon-avatar">
        <IconAvatar
          variant="LG"
          backgroundColor={theme.color.background.tertiary}
          defaultPlaceholderIcon="STORE"
          imageSource={{ uri: logoImage }}
          iconAccessibilityLabel="offer-logo-image"
        />
      </View>
    </ImageBackground>
  );
};

const styles = StyleSheet.create({
  heroImageLogo: {
    height: 160,
    width: '100%',
  },
  logo: {
    alignSelf: 'center',
    borderRadius: theme.spacing.xs,
    bottom: -28,
    height: 56,
    position: 'absolute',
    width: 56,
  },
});

export default SelfFundedOfferDetailsHeader;
